export default __webpack_public_path__ + "static/media/imdb.27d47be0.png";